<template>
  <div class="views">
    <ul class="views__header">
      <li class="views__title">
        {{chartTitle}}
      </li>
      <li class="views__tools">
        <el-button type="text" class="views__tools-button" :disabled="saveChart" @click="onSave">
          <i class="material-icons color_grey">save</i>
        </el-button>
        <el-button type="text" class="views__tools-button" v-if="!isEdit" @click="editChart">
          <i class="material-icons color_grey">edit</i>
        </el-button>
      </li>
    </ul>

    <el-card shadow="hover" class="views__card" v-loading="pending">
      <views-header :chart-name="name" />

      <views-body
        :data="data"
        :chart-name="name"
        :save-chart="saveChart"
        :title="chartTitle"
        @onSavedChart="handleSaved"
        @onSaveChart="handleSave"
      />
    </el-card>

  </div>
</template>

<script>
  // mixins
  import { audit } from "../../../../../../../mixins/audit";

  // components
  import ViewsHeader from "./header/ViewsHeader";
  import ViewsBody from "./body/ViewsBody";

  export default {
    name: "Views",
    data() {
      return {
        name: "Views",
        saveChart: false,
        chartTitle: this.$t('feed.audit.views.title'),
      };
    },
    components: {
      ViewsHeader,
      ViewsBody
    },
    mixins: [
      audit
    ],
  }
</script>

<style>
  .views__header {
    display: flex;
    justify-content: space-between;
    align-items: start;
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .views__title {
    margin-bottom: 20px;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;

    color: #5E6D82;
  }

  .views__tools .material-icons {
    font-size: 16px;
  }

  .views__tools {
    margin-top: 4px;
    margin-right: 15px;
  }

  .views__tools-button {
    padding: 0;
    color: #5e6d82;
  }

  .views__tools-button:hover {
    color: #B3BCCC;
    font-size: 12px;
  }

  .views__card {
    margin-bottom: 20px;
  }

  .hidden-chart-name {
    display: none;
    padding: 20px 10px;
    font-size: 16px;
  }
  .hidden-chart-name--visible {
    display: flex;
    justify-content: space-between;
  }
  .clone--hide {
    position: absolute;
  }
</style>
